import React from "react";
import { BsFileEarmarkArrowDown } from "react-icons/bs";
import { jsPDF } from "jspdf";
import html2canvas from "html2canvas";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FaRegFilePdf } from "react-icons/fa";
import { connect } from "react-redux";
import { setExportProcessing } from "app/redux/actions/ExportActions";

class FilesExport extends React.Component {
  state = {
    exporting: false,
  };

  exportJpg = () => {
    const { id, infoDivId, global, isBodyPart } = this.props;

    const chartDiv = document.querySelector(id);
    const infoDiv = document.getElementById(infoDivId)?.cloneNode(true);
    const chartInnerDiv = !global ? chartDiv.querySelector(".card-body") : chartDiv;

    if (infoDiv) {
      infoDiv.classList.remove("d-none");
      chartInnerDiv.insertAdjacentElement("afterbegin", infoDiv);
    }

    const canvasOptions = !this.props?.fullScreen
      ? {
          // scrollY: -window.scrollY + 100,
          scrollY: -window.scrollY + (isBodyPart ? 70 : 100),
          useCORS: true,
          allowTaint: true,
          // height: chartDiv.scrollHeight + chartDiv.scrollHeight / 2,
          height: chartDiv.scrollHeight + chartDiv.scrollHeight / (isBodyPart ? 11 : 2),
          // width: chartDiv.scrollWidth + chartDiv.scrollWidth / 7,
          width: chartDiv.scrollWidth + chartDiv.scrollWidth / 7,
          removeContainer: true,
        }
      : {
          scrollY: -window.scrollY,
          useCORS: true,
          allowTaint: true,
          height: chartDiv.scrollHeight,
          width: chartDiv.scrollWidth,
          removeContainer: true,
        };

    if (global) {
      this.props.setExportProcessing(true);
      canvasOptions.x = chartDiv.scrollWidth / 10;
      canvasOptions.y = chartDiv.scrollWidth;
    }

    this.setState({ exporting: true }, () => {
      html2canvas(chartDiv, canvasOptions).then((canvas) => {
        var a = document.createElement("a");

        a.href = canvas.toDataURL("image/jpeg");
        a.download = new Date().toLocaleString() + ".jpg";
        a.click();
        this.setState({ exporting: false });
        if (infoDiv) chartInnerDiv.removeChild(infoDiv);
        if (global) this.props.setExportProcessing(false);
      });
    });
  };

  printDocumentPdf = () => {
    const { id, infoDivId, global, isBodyPart } = this.props;
    const svgElements = document.querySelector(id).querySelectorAll("svg");
    svgElements.forEach((item) => item.setAttribute("font-size", "50px"));

    const chartDiv = document.querySelector(id);
    const infoDiv = document.getElementById(infoDivId)?.cloneNode(true);

    const chartInnerDiv = !global ? chartDiv.querySelector(".card-body") : chartDiv;

    if (infoDiv) {
      infoDiv.classList.remove("d-none");
      chartInnerDiv.insertAdjacentElement("afterbegin", infoDiv);
    }

    const canvasOptions = !this.props?.pendingRecordPopup
      ? {
          scrollY: -window.scrollY,
          useCORS: true,
          allowTaint: true,
          height: chartDiv.scrollHeight + chartDiv.scrollHeight / (isBodyPart ? 11 : 7),
          width: chartDiv.scrollWidth + chartDiv.scrollWidth / 7,
          removeContainer: true,
        }
      : {
          scrollY: -window.scrollY,
          useCORS: true,
          allowTaint: true,
          height: chartDiv.scrollHeight + chartDiv.scrollHeight / 3,
          width: chartDiv.scrollWidth + chartDiv.scrollWidth / 4,
          removeContainer: true,
          updateXValue: function () {
            let xValue = window.innerWidth / 14;
            this.x = xValue >= 90 ? xValue : 10;
          },
        };

    if (this.props?.pendingRecordPopup) canvasOptions.updateXValue?.();

    if (global) this.props.setExportProcessing(true);

    this.setState({ exporting: true }, () => {
      html2canvas(chartDiv, canvasOptions).then((canvas) => {
        const imgData = canvas.toDataURL("image/jpeg", 1.0);
        const imgWidth = canvas.width;
        const imgHeight = canvas.height;

        // A4 size in pixels at 96 DPI
        const a4WidthPx = 794; // = 210mm
        const a4HeightPx = 1123; // = 297mm

        let pdfWidth = a4WidthPx;
        let pdfHeight = (imgHeight * a4WidthPx) / imgWidth;

        // Prevent height overflow
        if (pdfHeight > a4HeightPx) {
          pdfHeight = a4HeightPx;
          pdfWidth = (imgWidth * a4HeightPx) / imgHeight;
        }

        const marginX = (a4WidthPx - pdfWidth) / 2;
        const marginY = (a4HeightPx - pdfHeight) / 2;

        const pdf = new jsPDF({
          orientation: "portrait",
          unit: "px",
          format: [a4WidthPx, a4HeightPx],
        });

        pdf.addImage(imgData, "JPEG", marginX, marginY, pdfWidth, pdfHeight);
        pdf.save(new Date().toLocaleString() + ".pdf");

        this.setState({ exporting: false });
        if (global) this.props.setExportProcessing(false);
        if (infoDiv) chartInnerDiv.removeChild(infoDiv);
      });
    });
  };
  render() {
    return (
      <div
        className={this.state.exporting || this.props.processing ? "d-none" : "d-flex"}
      >
        {!this.props.hideImgBtn ? (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-topeee">Download Image</Tooltip>}
          >
            <button
              onClick={this.exportJpg}
              style={{ background: "transparent", border: "0" }}
              className="btn btn-icon pr-0"
            >
              <BsFileEarmarkArrowDown color="#00b5ef" size="22" />
            </button>
          </OverlayTrigger>
        ) : (
          ""
        )}

        <OverlayTrigger
          placement="top"
          overlay={<Tooltip id="tooltip-topeee">Download Pdf</Tooltip>}
        >
          <button
            style={{ background: "transparent", border: "0" }}
            className="btn btn-icon pr-0"
            onClick={this.printDocumentPdf}
          >
            <FaRegFilePdf color="#00b5ef" size="20" />
          </button>
        </OverlayTrigger>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  processing: state.export.processing,
});

const mapDispatchToProps = {
  setExportProcessing: setExportProcessing,
};

export default connect(mapStateToProps, mapDispatchToProps)(FilesExport);
